import styled from 'styled-components';
import { spacing } from 'commons';

export const Main = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 5px;
  flex: 1;
`;

export const Label = styled.label`
  font-weight: 300;
  font-size: 12px;
  font-weight: 700;
`;

export const InputWrapper = styled.div`
  display: flex;
  overflow: hidden;
  border: 1px solid ${({ theme }) => theme.neutral_300};
  border-radius: ${spacing.input.borderRadius};
  background-color: ${({ theme }) => theme.neutral_100};
  width: 100%;
  height: ${spacing.input.height};

  input {
    outline: none;
    padding: 10px;
    font-weight: 300;
    font-size: 13px;
    text-align: center;
    width: 100%;
  }
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 20px;
  color: ${({ theme }) => theme.neutral_300};
`;

export const Division = styled.div`
  display: flex;
  align-self: center;
  width: 1px;
  height: calc(${spacing.input.height} - 12px);
  background-color: ${({ theme }) => theme.neutral_900};
  opacity: 0.1;
  border-radius: 1px;
`;
